// @flow
import { combineReducers } from 'redux';

import types from './types';
import { invalidatesRequest, requestTypes } from '../postflop/requestState';

export type ApiState = {
  loading: boolean,
  success: boolean,
  error: string,
}

const getTypes = (defaultType) => ({
  default: defaultType,
  success: `${defaultType}_SUCCESS`,
  error: `${defaultType}_ERROR`,
  reset: `${defaultType}_RESET`,
});

const initialState: ApiState = {
  loading: false,
  success: false,
  error: '',
};

const getReducer = (fullCurrentTypes) => (state: ApiState = initialState, action): ApiState => {
  switch (action.type) {
    case fullCurrentTypes.default:
      return {
        ...state,
        loading: true,
        success: false,
        error: '',
      };
    case fullCurrentTypes.success:
      return {
        ...state,
        loading: false,
        success: true,
        error: '',
      };
    case fullCurrentTypes.error:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
      };
    case fullCurrentTypes.reset:
    case types.SIGN_OUT:
      return { ...initialState };
    default:
      return state;
  }
};

const reducers = Object.keys(types).reduce((acc, type) => {
  const fullCurrentTypes = getTypes(type);
  return ({
    ...acc,
    [fullCurrentTypes.default]: getReducer(fullCurrentTypes),
  });
}, {});

const reduceApi = combineReducers(reducers);

export default (state, action) => {
  let next = reduceApi(state, action);
  if (action.type === `${types.GET_SIMILAR}_DROP`) {
    next = { ...next, [types.GET_SIMILAR]: { ...initialState } };
  }
  // Clear status with the invalidating action itself. A saga-dispatched RESET
  // can arrive after a React effect starts the replacement request and cancel it.
  Object.keys(requestTypes).forEach((kind) => {
    if (invalidatesRequest(kind, action)) {
      next = { ...next, [requestTypes[kind]]: { ...initialState } };
    }
  });
  return next;
};
